import { Currency } from '../constants/currency';
import { Locale } from '../constants/locale';
import { getLocale } from './locale';

export const getCurrency = () => {
    const locale = getLocale();
    return locale === Locale['en-US'] ? Currency.USD : Currency.CAD;
};
